'use strict';

var keyPair = require('./keyPair');
var wellKnown = require('./wellKnown');
var query = require('./wellKnown/query');
var types = require('./keyPair/types');
var types$1 = require('./wellKnown/types');



Object.defineProperty(exports, "generateKeyPair", {
  enumerable: true,
  get: function () { return keyPair.generateKeyPair; }
});
Object.defineProperty(exports, "issueDID", {
  enumerable: true,
  get: function () { return wellKnown.issueDID; }
});
Object.defineProperty(exports, "queryDidDocument", {
  enumerable: true,
  get: function () { return query.queryDidDocument; }
});
Object.keys(types).forEach(function (k) {
  if (k !== 'default' && !Object.prototype.hasOwnProperty.call(exports, k)) Object.defineProperty(exports, k, {
    enumerable: true,
    get: function () { return types[k]; }
  });
});
Object.keys(types$1).forEach(function (k) {
  if (k !== 'default' && !Object.prototype.hasOwnProperty.call(exports, k)) Object.defineProperty(exports, k, {
    enumerable: true,
    get: function () { return types$1[k]; }
  });
});
